module.exports = __webpack_public_path__ + "img/nova.765ae5c8.png";